<template>
	<popup
			@updateClosePopup="onCloseDialog"
			@updateSave="onSave"
			height-head="40px"
			:title="getTitle"
			:fullscreen="false"
			:width="managerStatementsItem ? '1400' : '340'"
			:btn-text="managerStatementsItem ? 'Confirm' : 'Generate'"
			:is-hide-bottom="isEdit"
	>
		<main-table
				v-if="managerStatementsItem"
				padding="0 0 10px"
				:headers="getHeaders"
				:listItems="managerStatementsItem"
				:is-hide-header="false"
				:is-pagination="false"
				:is-last-row="false"
		></main-table>
		<div v-else>
			<field
					margin="10px 0 0 0"
					width="300px"
					label="Period"
					placeholder="Select period"
					@updateSelect="onSelect($event, 'month')"
					:autocompleteValue="month"
					:items="managerStatementsMonth"
					:isClearable="false"
					item-text="name"
					item-value="date"
					is-select
			></field>
			<field
					:class-error="$v.department && $v.department.$error"
					margin="10px 0 16px 0"
					width="300px"
					label="Department"
					placeholder="Select department"
					@updateSelect="onSelect($event, 'department')"
					:autocompleteValue="department"
					:items="managerStatementsDepartments"
					:isClearable="false"
					is-select
					is-required
			></field>
			<template v-if="isAdvertising">
				<div v-if="manager">{{ manager }}</div>
				<field
						:class-error="$v.advertising && $v.advertising.$error"
						margin="16px 0 20px 0"
						width="300px"
						label="Advertising"
						type="number"
						placeholder="Enter sum"
						:setInputValue="advertising"
						@updateInput="onInput"
						icon="dollar"
						is-required
				></field>
			</template>
		</div>
	</popup>
</template>

<script>
import { mapActions } from "vuex";
// components
import Popup from "@/shared/Popup/Popup";
// validations
import { minValue, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
// constants
import tableHeaders from "@/components/Accounting/ManagerStatements/ManagerStatementsForm/tableHeaders";

export default {
	name: "ManagerStatementsForm",
	mixins: [ validationMixin ],
	components: { Popup },
	props: {
		managerStatementsItem: Array,
		isEdit: Boolean,
		managerStatementsMonth: Array,
		managerStatementsDepartments: Array
	},
	computed: {
		getHeaders() {
			return tableHeaders[this.department];
		},
		getTitle() {
			if (this.managerStatementsItem && this.department) {
				return this.managerStatementsDepartments.find(item => item.id === this.department).value;
			} 
			return 'Department1';
		}
	},

	validations() {
		const advertising = this.isAdvertising ? { required, minValue: minValue(0) } : {};
		return {
			department: { required },
			advertising,
		};
	},

	data: () => ({
		month: null,
		department: null,
		advertising: null,
		manager: null,
		isAdvertising: false
	}),
	methods: {
		...mapActions([
			'getManagerStatementsCreate',
			'actionPreloader',
			'onManagerStatements',
			'setAlert',
		]),
		async onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				if (this.managerStatementsItem) {
					this.actionPreloader(true);
					const { status } = await this.onManagerStatements(this.managerStatementsItem);
					if (status) {
						this.onCloseDialog(1);
						this.setAlert({ type: "success", message: "Manager statement saved successfully" });
					} else {
						this.setAlert({ type: "error", message: "Manager statements safe error" });
					}
					this.actionPreloader(false);

				} else {
					this.actionPreloader(true);
					const { month: { date, name }, department, advertising } = this.$data;
					const values = { month: date, month_name: name, department };
					if (this.isAdvertising) values.advertising = advertising;
					await this.getManagerStatementsCreate(values);
					this.actionPreloader(false);
				}
			} else {
				this.setAlert({ type: "error", message: "Manager statements safe error" });
			}
		},
		onCloseDialog(value) {
			this.$emit('updateCloseDialog', value);
		},
		async onSelect({ value }, key) {
			this[key] = value?.id || value;
			this.isAdvertising = this[key] === 2;
			this.manager = value?.manager;
		},
		onInput({ value }) {
			this.advertising = value;
		}
	},
	beforeMount() {
		if (this.managerStatementsItem) this.department = +this.managerStatementsItem[0].department;
		this.month = this.managerStatementsMonth[0];
	}
};
</script>

<style scoped lang="scss">

</style>
